import { Injectable } from '@angular/core';

import { MyBetsConfig } from '@frontend/sports/common/client-config-data-access';

@Injectable()
export class EditBetTimeoutProvider {
    constructor(private editBetConfig: MyBetsConfig) {}

    // For EditBet the timeout is oftype Date, because we want to have a fixed point in time(now() + 30s) when
    // the EditBet process should be stopped(ex. due to EP failure on backend)
    // Having the timeout as number, will just apply it for the current getStatus request, expecting it
    // to finish in X seconds
    getTimeoutDate(): Date {
        const timeoutInMilliseconds = (this.editBetConfig.editMyBetTimeout || 30) * 1000;

        return new Date(Date.now() + timeoutInMilliseconds);
    }
}
